import { useContext, useEffect, useState } from "react";
import { fetchData } from "../../utils/fetch";
import { LanguageContext } from "../../utils/lang_provider";
import { Carousel, Divider, Flex, Skeleton } from "antd";
import { fetchImage } from "../../utils/fetch";
import "../../styles/article.css"
import "../../styles/video_style.css"

export default function ArticlePage({ type, link }) {
    const [article, setArticle] = useState(null);
    const { language } = useContext(LanguageContext);
    const [ slidersImages, setSlidersImages ] = useState([]);
    const [ slidersImagesLoaded, setSlidersImagesLoaded] = useState(false);
    const carouselFlexStyle = {
      padding: "40px 20px 20px 20px", 
      margin: "10px",
      backgroundColor: "rgba(200,200,200,0.1)",
      borderRadius: "8px"
    };
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
    
    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= 1050);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    const imgStyle = {
      width: isMobile ? 300 : 500, 
      height: 500,
      objectFit: "cover",
      display: "block"
    };
    const carouselStyle = {
      width: isMobile ? 300 : 500, 
      height: 500, 
      margin: "10px" 
    };
    const divStyle = {
      width: isMobile ? 300 : 500, 
      height: 500, 
    };

    useEffect(() => {
      async function loadArticleAndImages() {
        try {
          const articleData = await fetchData(`front/${type}/${link}`, language);
          setArticle(articleData);

          const response = await fetchImage(`front/images/${type}/${articleData.id}`, language);
          const data = await response.json();

          const images = await Promise.all(
            data.images.map(async (filename) => {
              const imageResponse = await fetchImage(`front/images/${type}/${articleData.id}/${filename}`, language);
              const blob = await imageResponse.blob();
              return URL.createObjectURL(blob);
            })
          );

          setSlidersImages(images);
          setSlidersImagesLoaded(true);
        } catch (error) {
          console.error("Could not load article or images: ", error);
          setSlidersImages([]);
          setSlidersImagesLoaded(false);
        }
      }

      loadArticleAndImages();
    }, [type, link, language]);

  return (
    <div style={{margin: "0 10% 5% 10%"}}>
      <Flex vertical justify="center" align="center">
        {article ? (
          <Flex vertical justify="center">
            <h1>{article.title}</h1>
            <div dangerouslySetInnerHTML={{__html: article.content}}/>
            <Divider></Divider>
            {slidersImagesLoaded
            ?
            <Flex vertical={isMobile} style={carouselFlexStyle} justify="space-around" align="center">
              <Carousel arrows autoplay style={carouselStyle}>
                {slidersImages
                  .filter((_, index) => index % 2 === 0)
                  .map((src, index) => (
                    <div key={`odd-${index}`} style={divStyle}>
                      <img src={src} alt={`article-img-${index}`} style={imgStyle} />
                    </div>
                  ))}
              </Carousel>
              <Carousel arrows autoplay style={carouselStyle}>
                {slidersImages
                  .filter((_, index) => index % 2 !== 0)
                  .map((src, index) => (
                    <div key={`even-${index}`} style={divStyle}>
                      <img src={src} alt={`article-img-${index}`} style={imgStyle} />
                    </div>
                  ))}
              </Carousel>
            </Flex>
            : <></>
            }
          </Flex>
        ) : (
          <Skeleton></Skeleton>
        )}
      </Flex>
    </div>
  );
}